
export default function Dashboard() {
    return(
        <div>Dashboard here</div>
    )
}